import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LangContext } from '../contexts/langContext';
import { ChatStateContext } from '../contexts/chatStateContext';
import { SocialContext } from '../contexts/socialContext';
import { StateContext } from '../contexts/stateContext';
import { Avatar } from './UiKit/Avatar';
import { AvatarName } from './UiKit/AvatarName';
import { Button } from './UiKit/Button';
import { EditName, parseGroupDescription } from './UiKit/EditName';
import { PopoverH, TooltipH } from './UiKit/TooltipH';
import { Logo } from './UiKit/Logo';
import { UserDropDown } from './UiKit/UserDropDown';
import { Pop } from './UiKit/Pop';
import { Icon } from './UiKit/Icon';


export function GroupInfo(props) {

  const {
    group,
    updateGroup = () => void (0),
    invited = [],
    members = [],
    admins = [],
    myRequests = [],
    setGroupBrowser,
    requestToJoin = () => void (0),
    fetchMembers,
    fetchMyRequests
  } = { ...props }

  const navigate = useNavigate();
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const chatState = useContext(ChatStateContext);
  const $ui = context.$ui;

  const imAdmin = Boolean(admins.filter(u => u.user.token === context.me.user.token).length);

  const imThere = members.filter(one => one.user.token === context.me.user.token).length
    ? true : false;
  const iRequested = myRequests.filter(one => one.token === group.token).length
    ? true : false;
  const groupInfo = parseGroupDescription(group.description);
  console.log('myRequests = ', myRequests);
  console.log('iRequested = ', iRequested);



  const [adminSettings, setAdminSettings] = useState(false);


  const [open, setOpen] = useState(false);
  const hide = () => {
    setOpen(false);
    setAdminSettings(false);
  };
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const getGroupData = (group) => {
    const groupData = parseGroupDescription(group.description);
    return {
      token: group.token,
      name: group.name,
      image: groupData.image || null,
      image2: groupData.image2 || null,
      description: groupData.description || null
    }
  }

  return (
    <>

      {adminSettings
        &&
        <Pop
          title={$ui('group_admin_title')}
          // icon='person_add'
          handleClose={() => setAdminSettings(false)}
        >

          <GroupAdminSettings
            {...props}
            group={group}
            imAdmin={imAdmin}
            iRequested={iRequested}
            setGroupBrowser={setGroupBrowser}
            hide={hide}
          />

        </Pop>}


      <div className={`x_group_top ${getGroupData(group).image2 ? 'x_group_top--image2' : ''}`}
        style={{ backgroundImage: getGroupData(group).image2 ? `` : 'https://cdn.prod.website-files.com/643f3bd2d71a69bb42b11dfb/66c6a95224458f5dc515a112_pattern.png' }}
      >

        <div className="x_group_top_actions">
          <a className='x_button x_button--ghost x_button--sm' href={`/g/${group.token}`} target='_blank'>
            <Icon>
              open_in_new
            </Icon>
            <span className="mobile_v_no">{$ui('group_open')}</span>
          </a>
        </div>




        {getGroupData(group).image2 && <div className="x_group_image2" style={{ backgroundImage: `url(${getGroupData(group).image2})` }}></div>}



        <div className="x_group_title0">

          <div className="x_group_info0">
            <div className="_f _fm _fl _fwrap _fgap1">
              <div className="x_group_title">
                {group.name}
              </div>
            </div>
            {Boolean(groupInfo.description) && <div className="x_group_description">
              {groupInfo.description}
            </div>}
          </div>


          <div className="x_group_users_container">

            <div className="x_group_actions _fm">






              {
                !imThere
                && iRequested
                && <PopoverH
                  // trigger="click"
                  open={open}
                  onOpenChange={handleOpenChange}
                  title={<>
                    <GroupAdminSettings
                      {...props}
                      group={group}
                      imAdmin={imAdmin}
                      iRequested={iRequested}
                      setGroupBrowser={setGroupBrowser}
                      hide={hide}
                    />
                  </>}>
                  <div >
                    <Button ghost iconAfter='more_vert' sm>{$ui('group_requested')}</Button>
                  </div>
                </PopoverH>}


              {!imThere && !iRequested && <Button
                onClick={() => requestToJoin(group.token)}
              >
                {$ui('group_askinto')}
              </Button>}






              <div className="_fm _fgap06">
                <div className="x_group_users">
                  {members.map(one => <div className="x_group_user1 _fcc" key={`members-${one.user.token}`}>
                    <Avatar avatar={one.avatar} style={{ fontSize: '1.2em' }} />
                  </div>)}
                </div>


                <div className="x_group_quantity ">
                  {$ui('group_users', null, members.length || group.count)}: {members.length || group.count}
                </div>



              </div>

            </div>

            <div className="x_group_users_right">

              {imAdmin && <Button
                ghost
                icon='settings'
                labelMobileOff
                sm
                onClick={() => setAdminSettings(true)}
              >
                {$ui('group_admin_title')}
              </Button>}

              {/* {!imAdmin && <div className="mobile_v_no">
                <GroupAdminForNonAdmin {...props} />
              </div>} */}

              {!imAdmin && <>
                <PopoverH
                  placement='bottom'
                  content={<>
                    <GroupAdminForNonAdmin {...props} />
                  </>}>
                  <Button ghost icon='settings' sm></Button>
                </PopoverH>
              </>}


            </div>
          </div>

        </div>

        <div className="x0_logo x0_logo--group">
          <div className="x_logo_container">
            <Logo
              onClick={() => {
                context.me ? navigate(`/u/${context.me.user.token}`) : navigate('/')
              }}
            />
          </div>
        </div>
      </div>







    </>
  )
}


const GroupAdminForNonAdmin = (props) => {

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const chatState = useContext(ChatStateContext);
  const $ui = context.$ui;
  const {
    group,
    admins = [],
    fetchMembers,
    fetchMyRequests
  } = { ...props }

  return (
    <div className=" _fv _fl _fm _fgap08">

      <div className="x_group_admin0">
        <div className=" _f _fm _fgap08 ">

          <span className="x_group_admin_label">
            {$ui('group_admin', null, admins.length)}:
          </span>

          <div className="x_group_users">
            {admins.map(one => <div
              className="x_group_user1 _fcc"
              key={one.user.token}
            >
              <Avatar avatar={one.avatar} style={{ fontSize: '1.2em' }} />
            </div>)}
          </div>
          <Button
            icon='mail'
            ghost
            sm
            onClick={() => chatState.setCurrentChat(admins[0].user.token)}
          >
            {/* {$ui('chat_send_message')} */}
          </Button>

        </div>
      </div>

      <PopoverH
        title={<>
          <Button
            red
            icon='logout'
            sm
            onClick={() => context.x.leaveGroup(group.token, () => {
              fetchMembers?.();
              fetchMyRequests?.();
            })}
          >{$ui('group_leave')}
          </Button>
        </>}>
        <Button sm ghost red icon='logout'>
          {$ui('group_leave')}
        </Button>
      </PopoverH>

    </div>
  )

}


const GroupAdminSettings = ({
  group,
  imAdmin,
  invited,
  iRequested,
  setGroupBrowser = () => void (0),
  hide = () => void (0),
  updateGroup,
  fetchMembers,
  fetchMyRequests,
  fetchInvited,
}) => {

  const navigate = useNavigate();
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const chatState = useContext(ChatStateContext);
  const $ui = context.$ui;

  return (<>


    <div className="m_b_c_scroll">

      <div className="m_b_cols">
        <div className="m_b_form0">
          <div className="m_b_form">


            <div className="_fv">

              {!imAdmin && !iRequested && <Button red icon='delete'
                onClick={() => context.x.leaveGroup(group.token, () => {
                  fetchMembers();
                  fetchMyRequests();
                })}
              >{$ui('group_leave')}
              </Button>}

              {!imAdmin && iRequested && <Button red icon='delete'
                onClick={() => context.x.leaveGroup(group.token, () => {
                  fetchMembers();
                  fetchMyRequests();
                })}
              >{$ui('group_askinto_cancel')}
              </Button>}

              {imAdmin && <>

                <div className="_fv _f100 _fgap1 _fl">
                  {/* <div className="x_choose_section_title x_choose_section_title--v">
                {$ui('group_admin_title')}
                </div> */}


                  <EditName
                    fields={['name', 'description', 'image', 'image2']}
                    name={group.name}
                    desription={group.description || ''}
                    // placeholder='Set group name'
                    placement='bottom'
                    handleUpdate={(newName, newDescription) => {
                      updateGroup({
                        'token': group.token,
                        'name': newName,
                        'description': newDescription
                      })
                    }}
                  />

                  <Button
                    icon='person_add'
                    onClick={() => {
                      hide();
                      context.setState.chooseGroup(group.token);
                      setGroupBrowser?.(group.token);
                    }}
                  >
                    {$ui('group_add_user')}
                  </Button>

                  <GroupInvited
                    group={group}
                    invited={invited}
                    imAdmin={imAdmin}
                    fetchMembers={fetchMembers}
                    fetchMyRequests={fetchMyRequests}
                    fetchInvited={fetchInvited}
                  >
                  </GroupInvited>







                  <PopoverH
                    title={<>
                      <Button red icon='delete'
                        onClick={() => {
                          context.x.deleteGroup(group.token);
                          navigate('/');
                        }}
                      >{$ui('group_delete')}</Button>
                    </>}>
                    <div >
                      <Button ghost red icon='delete'>
                        {$ui('group_delete')}
                      </Button>
                    </div>
                  </PopoverH>
                </div>





              </>}

            </div>
          </div>
        </div>
      </div>
    </div>

  </>)
}


export const GroupInvited = ({
  invited = [],
  group,
  imAdmin,
  fetchMembers,
  fetchMyRequests,
  fetchInvited,
  children
}) => {
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;
  const navigate = useNavigate();
  return (

    <div className="_fv _fgap1 _fl _fwrap _f100">
      {invited.length > 0 && <div className="_fv _fgap04 _fl _fwrap _f100">
        <div className="_tnowrap">
          {$ui('group_invited')}:
        </div>

        <div className="x_group_invited_list">

            {invited
              .map(one => {
                return (
                  <div
                    className="x_group_invited_user"
                    key={`${one.user.token}`}
                  >

                    <UserDropDown
                      mobileIconsOnly
                      user={one.user}
                      avatar={one.avatar}
                      addComponent={<>
                        <div className="_f">
                          {/* <AvatarName avatar={one.avatar} /> */}
                          <Button ghost icon='arrow_forward' onClick={() => navigate(`/u/${one.user.token}`)}></Button>
                          <Button ghost icon='delete' red onClick={() => context.x.removeUserFromGroup(group.token, one.user.token, () => {
                            fetchInvited?.();
                            fetchMembers?.();
                            fetchMyRequests?.();
                          })} />
                        </div>

                      </>}
                    />

                    {/* <PopoverH content={<>
                    <div style={{
                      width: invited.length > 3 ? '4.6em' : '7em',
                      height: '2em',
                      fontSize: '0.8em',
                      fontWeight: '600',
                      marginRight: '-0.4em'
                    }} className="ellipsis"
                    placement='bottom'
                  >

                    <div className="_fv">
                      <AvatarName avatar={one.avatar} />
                      <Button ghost icon='arrow_forward' onClick={() => navigate(`/u/${one.user.token}`)}></Button>
                      <Button ghost icon='delete' red onClick={() => context.x.removeUserFromGroup(group.token, one.user.token, () => {
                        fetchInvited?.();
                        fetchMembers?.();
                        fetchMyRequests?.();
                      })} />
                    </div>
                  </div></>}
                  > */}
                    <div className="_fv _fcc _fgap02">
                      <Avatar
                        avatar={one.avatar}
                        style={{ fontSize: '1em' }}
                      />
                      <strong><AvatarName avatar={one.avatar} /></strong>
                    </div>
                    {/* </PopoverH> */}
                  </div>
                )
              })}

        </div>
      </div>}


    </div>

  )
}